import createImageUrlBuilder from "@sanity/image-url";
import {
  AllSanitySchemaTypes,
  internalGroqTypeReferenceTo,
} from "./sanity.types";

import { PREVIEW_MODE } from "@/env";

export function resolveReference<T>(obj: {
  _type: "reference";
  [internalGroqTypeReferenceTo]?: T;
}) {
  // if (obj._type === "reference")
  //   throw new Error("Asset reference has not been expanded!");
  return obj as unknown as Extract<AllSanitySchemaTypes, { _type: T }>;
}

const imageBuilder = createImageUrlBuilder({
  projectId: "cjufxbf8",
  dataset: "production",
});

export const urlForImage = (source: any) => {
  // Ensure that source image contains a valid reference
  if (!source?.asset?._type) {
    return undefined;
  }

  return imageBuilder?.image(source).auto("format").fit("max");
};

export function urlForOpenGraphImage(image: any) {
  return urlForImage(image)?.width(1200).height(627).fit("crop").url();
}

export const isPreviewMode = PREVIEW_MODE === "true";
